const main = {
  'Config GMC': 'Google Merchant Center - ショッピング広告設定',
  'Config GMC Caption':
    'Content API との連携により、商品データを Google Merchant Center に自動でアップロードし、Google 広告やその他の Google サービスで活用できます。\nGoogle Merchant Center のサブアカウントを連携してください。',
  'Merchant Center ID': 'Google Merchant ID',
  'Merchant Center ID - description_integrated':
    'Content API を有効にすると、商品データは以下の認証済みの Google Merchant Center アカウントへ送信されます。',
  'Merchant Center ID - action button_integrated': '設定を確認',
  'Preorder Period': '出荷準備日数',
  'Merchant has been saved successfully': '設定を保存しました',
  'Successfully set the Region and Language for Ads Delivery':
    '広告配信地域と言語を設定しました',
  'Please enter numbers only': '有効な GMC ID を入力してください',
  'Save before leaving': 'このページを離れる前に、必ず内容を保存してください。',
  'Authorize Content API Title':
    'Content API サービスアカウントのアクセス権限設定',
  'Authorize Content API Description':
    '<1>FAQ</1> の手順に従い、Google Merchant Center の管理画面で Content API サービスアカウントの認証情報を作成し、JSON キーファイルをダウンロード後、こちらにアップロードしてください。',
  'Config region & locale': '広告配信地域・言語設定',
  'Config region & locale Caption':
    'Google Merchant Center と連携後、本画面で商品フィードを管理・自動更新できます。\nGoogle Merchant Center は、設定した配信地域と言語に基づいて商品広告を配信します。',
  'Config region & locale Alert':
    '商品を正常にアップロードするには、配信言語に対応する商品タイトル、概要、説明を入力してください。',
  'Signed in with Google': 'Googleでログイン済み',
  "You're signed in with Google": 'Google 認証に正常にログインしました',
  'Automatically connect Merchant API — no manual setup required':
    'Merchant API を自動連携し、手動設定は不要です',
  'Go to Google Merchant Center': 'Google Merchant Center 管理画面へ',
  'Sign in with your Google account': 'Google 認証にログインしてください',
  'Sign in with Google': 'Google 認証にログイン',
  'Learn more': '詳しく見る',
  'Connect a new Google Merchant Center account?':
    'オンラインストアを新規作成した Google Merchant Center アカウントに連携しますか。',
  'When your store is connected to a Google Merchant Center account, disconnecting it will have the following effects:':
    'ストアがすでに Google Merchant Center（GMC） アカウントと連携している場合、連携を解除すると以下の影響があります：',
  'Website ownership will be transferred to the new GMC account.':
    'サイトの所有権が新しい GMC アカウントに移転されます。',
  'Product data will be synced to the new GMC account.':
    '商品データが新しい GMC アカウントに同期されます。',
  'Products in the original GMC account will be marked as "Disapproved".':
    '既存の GMC アカウントでは、商品が未承認として表示されます。',
  'Ad campaigns linked to the original GMC account will be interrupted.':
    '既存の GMC アカウントに紐づく広告配信が中断されます。',
  'The original GMC account will be deactivated and can no longer be used.':
    '既存の GMC アカウントは閉鎖され、使用できなくなります。',
  'A GMC sub-account has been created in your SHOPLINE MCA':
    'SHOPLINE MCA 内に GMC サブアカウントが作成されました。',
  'Create and connect Google Merchant Center account':
    'Google Merchant Center アカウントを作成・連携',
  'We will help you create a new GMC account using your authorized Google account and automatically connect it to SHOPLINE.':
    '認証済みの Google アカウントを使用して Google Merchant Center アカウントを作成し、SHOPLINE との連携を自動的に完了します。',
  'Connect now': 'ワンクリック連携',
  'A new Merchant Center account has been created and connected to your store. Please check your inbox and accept the Google Merchant Center admin invitation.':
    '新しい Merchant Center アカウントを作成し、連携が完了しました。メールを確認し、Google Merchant Center の管理者招待を承認してください。',
  'Website ownership has been transferred to this account.':
    'サイトの所有権はこのアカウントに移転されました。',
  'Product data will be synced to this account.':
    '商品データはこのアカウントに同期されます。',
  'Connected Merchant Center ID': '連携済み Merchant Center ID',
  Disconnect: '連携を解除',
  'Disconnect Google Merchant Center account?':
    'Google Merchant Center アカウントを解除しますか？',
  'Confirm Disconnect': '解除する',
  'Product data will stop syncing, and any ads linked to this account will be paused. Are you sure you want to disconnect from Google Merchant Center?':
    '商品データの同期が停止し、このアカウントに紐づいた広告配信が中断されます。Google Merchant Center との連携を解除してもよろしいですか？',
  'Let Google Merchant Center determine the shipping date for pre-order products.':
    'Google Merchant Center に予約商品の出荷日を判定させる',
  'Connect Merchant API': 'Merchant API 連携設定',
  'Through a Merchant API connection, your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    'Merchant API を連携することで、商品データを Google Merchant Center に即時自動更新でき、さらに Google 広告、YouTube Live Shopping 機能、その他の Google サービスで利用できます。',
  'Connect Merchant API Label': 'Merchant API を連携する',
  Recommended: '推奨',
  'Recommended for real-time product sync, hidden product setting, and simplified maintenance.':
    '推奨：商品データのリアルタイム同期や非公開商品の設定に対応し、運用管理を簡略化します',
  'Do not connect Merchant API': 'Merchant API を連携しない',
  'Product data will not sync automatically. You must manually update the Product Feed in Google Merchant Center. This may affect product approval and exposure.':
    '商品データは即時同期されず、Google Merchant Center で Product Feed を手動更新する必要があります。これにより、商品の掲載状態や露出に影響する可能性があります。',
  'Saved successfully': '保存しました',
  'Setup incomplete': '設定が未完了です',
  'Placement area and placement language are not configured':
    '配信地域と言語が未設定です',
  'Merchant API settings not saved':
    'Merchant API 設定がまだ保存されていません',
  'The system will temporarily save your settings as "Not connected to Merchant API".':
    'システムは一時的に「Merchant API を連携しない」として保存します。',
  'Apps Store': '拡張機能ストア',
  'My Apps': 'マイ拡張機能',
  'If you need to manage the Google Merchant Center account, please contact the account owner and request manual authorization in the Google Merchant Center dashboard.':
    'Google Merchant Center アカウントを管理する必要がある場合は、そのアカウントを作成した管理者に連絡し、Google Merchant Center 管理画面で手動で権限を付与してください。',
  'Are you sure you want to cancel?': '変更をキャンセルしますか',
  'Any unsaved changes will be lost.':
    '編集内容は保存されません。変更をキャンセルしてもよろしいですか？',
  'Continue editing': '編集を続ける',
  'Cancel changes': '変更をキャンセル',
  "Your edits aren't saved": '変更が保存されていません',
  'If you leave, any unsaved changes will be lost. Please save before leaving.':
    'このまま離れると、編集内容は保存されません。保存してから離れることをお勧めします。',
  Leave: '離れる',
  'Once you sign in, the Merchant API will be automatically connected to SHOPLINE with no manual setup needed. Your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    'ログイン後、Merchant API は自動で SHOPLINE に連携され、手動設定は不要です。商品データは Google Merchant Center に即時更新され、Google 広告、YouTube Live Shopping およびその他の Google サービスで利用できます。',
  'Once you sign in, We will help you create and connect the Merchant Center account.':
    'ログイン後、当社が自動で Merchant Center アカウントを作成し連携します。',
  'Your store is currently connected to Google Merchant Center (GMC). Signing in will disconnect the existing GMC account and automatically create and connect a new one.':
    '現在オンラインストアには Google Merchant Center（GMC）が連携済みです。ログイン後、既存の GMC アカウントの連携を解除し、新しい GMC アカウントを自動作成して連携します。',
  'Ad Placement Area and Language': '配信地域と言語',
  'The system will upload your products (including preorder and hidden products) to Google Merchant Center. Product ads will be displayed based on the selected placement area and language.':
    'システムが商品（予約商品・非表示商品を含む）を Google Merchant Center にアップロードした後、設定した配信地域と言語に基づいて商品広告が表示されます。',
  'Please enter the product name, summary, and description for the selected placement language to ensure successful product uploads.':
    'ご注意：配信用言語に合致する商品タイトル・概要・説明を入力している必要があります。',
  'Add a language to the list below': '下のリストに言語を追加',
  Region: '配信地域',
  Locale: '配信言語',
  'Please contact the Online Merchant Success Team to enable this feature for your store.':
    'カスタマーサポートに連絡して、この機能の権限を有効にしてください。',
  'To reconnect to Google Merchant Center, a new GMC account will be created following the new process to comply with Google\'s latest API standards. Please contact the Online Merchant Success Team to enable the "Automatically create and connect Merchant API" feature.':
    '再度 Google Merchant Center と連携する場合は、Google の最新 API 規範に準拠した新しい接続プロセスで新しい GMC アカウントが作成されます。 「自動で Merchant API を作成・連携する」新機能の有効化については、カスタマーサポートまでご連絡ください。',
  'Sign in and authorize now to upgrade from Content API to Merchant API':
    '今すぐログインして認証し、Content API を Merchant API にアップグレードしましょう。',
  'Due to Google policy changes, the Content API will be deprecated on 18 August 2026, and replaced by the Merchant API.':
    'Google のポリシー変更に伴い、Content API は 2026 年 8 月 18 日に廃止され、Merchant API に置き換えられます。',
  'Please complete the API upgrade as soon as possible to prevent any disruption to product uploads and ad delivery.':
    '早めに API のアップグレードを推奨します。アップグレードしない場合、商品のアップロードや広告配信に影響が出る可能性があります。',
  'Once authorized, you can upgrade to the Merchant API instantly with no manual setup required.':
    'ログイン認証後はワンクリックで Merchant API にアップグレードでき、手動設定は不要です。',
  "We recommend that the store owner perform the authorization to avoid disruptions caused by changes to a staff member's account status or permissions.":
    'ストアマネージャーが認証を行うことをお勧めします。認証担当者の GMC アカウントが無効化または権限変更された場合、商品アップロードや広告配信に影響を及ぼす可能性があります。',
  "If the authorized staff member's GMC account is suspended or permissions change, product uploads and ad delivery will be affected. If any changes occur, please contact the Online Merchant Success Team.":
    '認証担当者の GMC アカウントが無効化または権限変更された場合、商品のアップロードや広告配信に影響が出る可能性があります。変更があった場合はカスタマーサポートまでご連絡ください。',
  'Google discontinued the Content API on 18 August 2026. Please upgrade to the Merchant API to keep syncing product data with your GMC account.':
    'Google は 2026 年 8 月 18 日に Content API の提供を終了しました。GMC アカウントへの商品データの同期を継続するには、Merchant API に移行してください。',
  'Successfully upgraded to Merchant API':
    'Merchant API へアップグレードしました。',
  'Content API has been upgraded to Merchant API. Your previous settings have been automatically applied. No reconfiguration is needed.':
    'Content API は Merchant API にアップグレードされ、既存の設定は自動的に引き継がれています。再設定の必要はありません。',
  'Upgrade Content API to Merchant API':
    'Content API を Merchant API にアップグレード',
  'If you need to disconnect Google Merchant Center, please contact the Online Merchant Success Team for assistance.':
    'Google Merchant Center の連携解除をご希望の場合は、カスタマーサービスまでお問い合わせください。',
  'Disconnect Google Merchant Center?':
    'Google Merchant Center との連携を解除しますか？',
  'Product data syncing will stop, and ads linked to this account will be interrupted.':
    '商品データの同期が停止し、このアカウントに紐づく広告配信が中断されます。',
  'Your current Google account does not have administrative access to this GMC account. Please contact the store owner for authorization.':
    '現在ご利用中のGoogleアカウントには当該GMCの管理権限がありません。権限付与については、店長にご連絡ください。',
  'Insufficient permissions. Please log in to Google again and grant the required access.':
    '権限が不足しています。もう一度 Google にログインし、権限付与を完了してください。',
  'The shipping delay days cannot be left blank or set to fewer than 30.':
    '出荷延期日数は空欄または30未満にはできません',
  DATA_TABLE: {
    REGION: '地域',
    LOCALE: '言語',
    ACTION: '有効/無効',
  },
  LOCALE: {
    'zh-hant': '中国語（台湾）',
    'zh-tw': '中国語（台湾）',
    'zh-hk': '中国語（香港）',
    'zh-cn': '中国語（中国）',
    en: '英語',
    ms: 'マレー語',
    th: 'タイ語',
    vi: 'ベトナム語',
    id: 'インドネシア語',
    de: 'ドイツ語',
    fr: 'フランス語',
    ja: '日本語',
  },
  REGION: {
    TW: '台湾',
    CN: '中国',
    HK: '香港',
    SG: 'シンガポール',
    MY: 'マレーシア',
    TH: 'タイ',
    VN: 'ベトナム',
    PH: 'フィリピン',
    US: 'アメリカ合衆国',
    AU: 'オーストラリア',
    GB: 'イギリス',
  },
  UNIT: {
    days: '日',
  },
};

export default main;
